import {environment} from "../../environments/environment";

export function isProdEnvironment(): boolean {
	return environment.env === 'prod';
}